const module = { name: 'movie/shared/desktop/mopReviews', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_movieReviews_movieDetails_context } from 'require-core';

const { movieReviews, movieDetails, context: { req: { route }, featureFlags } } = Fandango_movieReviews_movieDetails_context;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



import { fd_url_manager as links } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const { id, isReleaseInFuture, releaseDate, reviewsType, writeUserReview } = readPageContext(movieReviews, movieDetails)


const Selectors = {
    RATINGS_TABS_CONTAINER: '.js-reviews__ratings-tabs',
    MOP_CRITIC_CONTAINER: '.js-reviews__rt-critic-container-mop',
    MOP_AUDIENCE_CONTAINER: '.js-reviews__rt-audience-container-mop',
    MORE_INFO_BTN: '#movie-rating-more-info',
    MORE_INFO_MODAL: '#more-info-modal',
    REVIEWS_CRITIC_CONTAINER: '.js-reviews__rt-critic-container-reviews',
    REVIEWS_AUDIENCE_CONTAINER: '.js-reviews__rt-audience-container-reviews'
}


const RouteNames = {
    MOP: 'mop',
    REVIEWS: 'reviews'
}


const HTTPStatusCodes = {
    OK: 200,
    NOT_FOUND: 404
}


const ReviewsTypes = {
    CRITIC: 'critic',
    MOVIE: 'movie',
}
function readPageContext(movieReviews, movieDetails) {
    const { id, isReleaseInFuture, releaseDate, writeUserReview } = movieDetails || {};
    const { reviewsType } = movieReviews || {};
    return {
        id: id || '',
        isReleaseInFuture: Boolean(isReleaseInFuture),
        releaseDate: releaseDate || '',
        reviewsType: reviewsType || '',
        writeUserReview,
    };
}
function isAllDisplayDataMissing(apiData) {
    const { audienceRating, audienceReviews, audienceScore, criticsRating, criticsReviews, criticsScore } = apiData || {};
    if ((!criticsRating || criticsRating === '')
        && (!criticsScore || criticsScore < 1)
        && (!criticsReviews || criticsReviews.length < 1)
        && (!audienceRating || audienceRating === '')
        && (!audienceScore || audienceScore < 1)
        && (!audienceReviews || audienceReviews.length < 1)) {
        return true;
    }
    return false;
}
function updateUI(apiData) {
    const criticsULEle = document.querySelector(Selectors.MOP_CRITIC_CONTAINER) || document.querySelector(Selectors.REVIEWS_CRITIC_CONTAINER);
    const isAllDataMissing = isAllDisplayDataMissing(apiData);
    const isAudienceScoreNA = new Date(releaseDate).getFullYear() <= 2009;
    const isCriticReviews = reviewsType === ReviewsTypes.CRITIC;
    const isMovieReviews = reviewsType === ReviewsTypes.MOVIE;
    const isMOPRoute = route === RouteNames.MOP;
    const isReviewsRoute = route === RouteNames.REVIEWS;
    if (apiData.status !== HTTPStatusCodes.OK) {
        const viewModel = {
            hasErrors: true,
            isCriticReviews,
            isMovieReviews,
            isMOPRoute,
            isReviewsRoute,
        };
        const markup = swig.render('_rtCriticReviews', viewModel);
        criticsULEle.innerHTML = markup;
        return;
    }
    const criticViewModel = {
        hasErrors: false,
        isCriticReviews,
        isMovieReviews,
        isMOPRoute,
        isReviewsRoute,
        ratings: {
            criticsRating: apiData.criticsRating,
            criticsScore: apiData.criticsScore,
        },
        reviews: apiData.criticsReviews,
        isReleaseInFuture,
        isReviewable: apiData.isReviewable,
        releaseDate,
        reviewsURL: apiData.rottenTomatoesUrl,
        isAllDataMissing
    };
    const criticMarkup = swig.render('_rtCriticReviews', criticViewModel);
    criticsULEle.innerHTML = criticMarkup;
    const audienceViewModel = {
        status: apiData.status,
        isCriticReviews,
        isMovieReviews,
        isMOPRoute,
        isReviewsRoute,
        reviews: apiData.audience.reviews,
        audienceRating: apiData.audienceRating,
        audienceScore: apiData.audienceScore,
        isReviewable: apiData.isReviewable,
        releaseDate,
        isReleaseInFuture,
        reviewsURL: apiData.rottenTomatoesUrl,
        writeUserReview,
        isAllDataMissing,
        rottenTomatoesAboutURL: links.rottenTomatoesAbout(),
        usePopovers: featureFlags.usePopovers,
    };
    const audienceMarkup = swig.render('_rtAudienceReviews', audienceViewModel);
    const audienceULEle = document.querySelector(Selectors.MOP_AUDIENCE_CONTAINER) || document.querySelector(Selectors.REVIEWS_AUDIENCE_CONTAINER);
    audienceULEle.innerHTML = audienceMarkup;
    if (route === RouteNames.REVIEWS && !isAllDataMissing) {
        const viewModel = {
            ratings: {
                audienceRating: apiData.audienceRating,
                audienceScore: apiData.audienceScore,
                criticsRating: apiData.criticsRating,
                criticsScore: apiData.criticsScore,
                isAudienceScoreNA,
                certifiedFresh: apiData.certifiedFresh,
            },
            isReviewable: apiData.isReviewable,
            isCriticReviews,
            isMovieReviews,
            rottenTomatoesEnabled: featureFlags.rottenTomatoesEnabled
        };
        const markup = swig.render('_movieRatingsTabs', viewModel);
        document.querySelector(Selectors.RATINGS_TABS_CONTAINER).innerHTML = markup;
        modal.init(Selectors.MORE_INFO_BTN, Selectors.MORE_INFO_MODAL);
    }
    const { EventNames } = eventQueue;
    const payload = {
        data: {
            criticsScore: apiData.criticsScore,
            criticsRating: apiData.criticsRating,
            audienceScore: apiData.audienceScore,
            audienceRating: apiData.audienceRating
        }
    };
    eventQueue.emit(EventNames.MOP_FAN_CRITIC_REVIEWS_API, payload);
}
function formatAudReviews(review) {
    if (!review || !review.rating) {
        return null;
    }
    const fullStars = Math.trunc(review.rating);
    const halfStar = (review.rating % 1 === 0.5) ? 1 : 0;
    return {
        ...review,
        rating: {
            fullStars,
            halfStar
        }
    };
}
function getAudViewModel(reviews) {
    if (!reviews) {
        return {};
    }
    return {
        reviews: Array.isArray(reviews.reviews) ? reviews.reviews.map(formatAudReviews) : [],
        isReviewable: reviews.isReviewable,
        reviewsURL: reviews.rottenTomatoesUrl
    };
}
function onAllFail(err) {
    debugLog.warn(`${route} | ratings + reviews`, err);
    updateUI({
        status: HTTPStatusCodes.NOT_FOUND
    });
}
function onAllDone(reviewData = {}) {
    if (!reviewData.data) {
        return updateUI({
            status: HTTPStatusCodes.NOT_FOUND
        });
    }
    updateUI({
        status: HTTPStatusCodes.OK,
        ...reviewData.data,
        audience: getAudViewModel(reviewData.data),
        criticsReviews: route === RouteNames.MOP && Array.isArray(reviewData.data.criticsReviews) ? reviewData.data.criticsReviews.splice(0, 10) : reviewData.data.criticsReviews
    });
}
function getReviews() {
    if (!featureFlags.rottenTomatoesIntlEnabled) {
        return;
    }
    xhr.ajax({
        method: 'GET',
        url: links.napiFanAndCriticReviews({ id, pageSize: 10 }),
    }).done(onAllDone).fail(onAllFail);
}
function init() {
    getReviews();
}
module.exports = {
    init
};
export default module.exports;